module.exports = __webpack_public_path__ + "img/hz-fy.e15e8add.jpg";